export const SGHODA_TOKEN_ADDRESS = "0xe0B82d38659EfC4da53E9772544660470DeB6ffC".toLowerCase();
export const GHODA_TOKEN_ADDRESS = "0xB08F0ee6Bc6c29c4D3Feb74B2402295EfD2B49C9".toLowerCase();
export const ELO_TOKEN_ADDRESS = "0xe5E5308919eFc0CCc2622671f31c83F22b11dC2A".toLowerCase();
export const NFT_TOKEN_ADDRESS = "0x8dF24D7aeE61dC1C985597e68EC5b2700368Fd41".toLowerCase();
